// tree-cell-template.directive.ts
import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[treeHeaderTemplate]',
  standalone: true,
})
export class TreeHeaderTemplateDirective {
  @Input('treeHeaderTemplate') name!: string; // e.g. "status", "link"

  constructor(public template: TemplateRef<unknown>) {}
}
